import { Flex, Heading, Tabs, TabList, Tab, TabPanels, TabPanel } from "@chakra-ui/react";
import { GameHistoryPanel } from "../components";
import { GAME_HISTORY_NAMES } from "../utils/gameHistoryNames";

const GAME_TABS = [
  { gameName: GAME_HISTORY_NAMES.COUNTING, label: "Counting Game" },
  { gameName: GAME_HISTORY_NAMES.TEAMS, label: "2v2 Teams" },
  { gameName: GAME_HISTORY_NAMES.CUTTHROAT, label: "Cutthroat" },
];

const GameHistory = () => {
  return (
    <Flex direction="column" align="center" gap="24px" p={{ base: 4, md: 8 }}>
      <Heading as="h2" size="lg" color="headline.400" fontStyle="italic">
        Game History
      </Heading>

      <Tabs isFitted isLazy variant="line" w="100%" maxW="600px">
        <TabList>
          {GAME_TABS.map(({ gameName, label }) => (
            <Tab
              key={gameName}
              _selected={{
                color: "headline.600",
                borderBottomColor: "headline.600",
              }}
            >
              {label}
            </Tab>
          ))}
        </TabList>
        <TabPanels>
          {GAME_TABS.map(({ gameName, label }) => (
            <TabPanel key={gameName} padding={0}>
              <GameHistoryPanel gameName={gameName} label={label} />
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Flex>
  );
};
export default GameHistory;
